import { RouteLocationRaw } from "vue-router";

export function isExternalLink(to: undefined | RouteLocationRaw | string) {
  return typeof to === "string" && to.startsWith("http");
}
